import { render, staticRenderFns } from "./card-start-ratio.vue?vue&type=template&id=04070df4&"
import script from "./card-start-ratio.vue?vue&type=script&lang=js&"
export * from "./card-start-ratio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports